module.exports = __webpack_public_path__ + "static/media/damlag2_480.89d01c14.jpg";